/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_ReopenInputs */

const en_pc_online_cmp_reopen = /** @type {(inputs: Pc_Online_Cmp_ReopenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reopen a closed tab, reveal the file in its folder`)
};

const zh_pc_online_cmp_reopen = /** @type {(inputs: Pc_Online_Cmp_ReopenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新打开已关闭的标签页、在文件夹中显示文件`)
};

/**
* | output |
* | --- |
* | "Reopen a closed tab, reveal the file in its folder" |
*
* @param {Pc_Online_Cmp_ReopenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_reopen = /** @type {((inputs?: Pc_Online_Cmp_ReopenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_ReopenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_reopen(inputs)
	return zh_pc_online_cmp_reopen(inputs)
});
export { pc_online_cmp_reopen as "pc.online.cmp.reopen" }